import { useInfiniteQuery } from "@tanstack/react-query";
import { SmsContact } from "../types/SmsContact";
import { fetchSmsContacts } from "../../actions/fetchSmsContacts.actions";

export const SMS_CONTACTS_QUERY_KEY = ["sms", "contacts"] as const;

export const getSmsContactsQueryKey = (sessionNumber?: string) => [
  ...SMS_CONTACTS_QUERY_KEY,
  sessionNumber || "no-session",
];

export interface PaginatedSmsContactsResponse {
  data: SmsContact[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export const useSmsContactsQuery = (sessionNumber?: string, limit = 20) =>
  useInfiniteQuery<PaginatedSmsContactsResponse, Error>({
    queryKey: [...getSmsContactsQueryKey(sessionNumber)],
    queryFn: ({ pageParam = 1 }) =>
      fetchSmsContacts({
        from: sessionNumber || "",
        page: Number(pageParam),
        limit,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage.meta.hasNextPage) return undefined;
      return lastPage.meta.page + 1;
    },
    enabled: !!sessionNumber,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });